// extracted by mini-css-extract-plugin
module.exports = {"layout":"layout_layout__E48_k","content":"layout_content__hN3QC"};